import ConfirmationSignalScheduleDeprecatedRoot from '../../components/pages/ConfirmationSignalScheduleDeprecated';
import { FullHeightOnly } from '../../components/shared/Grid';
import TemplateCenter from '../../layout/TemplateCenter';
/**
 * @deprecated Esta página é uma versão antiga da confirmação de agendamento
 */
const ConfirmationSignalScheduleDeprecated = () => {
  return (
    <TemplateCenter>
      <FullHeightOnly>
        <ConfirmationSignalScheduleDeprecatedRoot />
      </FullHeightOnly>
    </TemplateCenter>
  );
};

export default ConfirmationSignalScheduleDeprecated;
